// angular modules
import { NgModule, ErrorHandler } from '@angular/core';
import { BugsnagService } from './bugsnag.service';
import { BcErrorHandler } from './bc-error-handler.service';
import { UserStateService } from '../../services/user-state.service';


// create a factory which will return the bugsnag error handler
export const errorHandlerFactory = (bugnsagService: BugsnagService, userService: UserStateService) => {
  return new BcErrorHandler(bugnsagService, userService);
};

@NgModule({
  providers: [
    {
      provide: BcErrorHandler,
      useFactory: errorHandlerFactory,
      deps: [BugsnagService, UserStateService]
    },
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory,
      deps: [BugsnagService, UserStateService]
    }
  ]
})
export class BcBugSnagModule { }
